/**
 * Eine Wahl aus Stufen als Reihe gleich breiter Knöpfe.
 * (29.09.2026 — bis dahin in lib/schnell-einstellungen.ts)
 *
 * EIN Baustein für jede Segment-Wahl, die die Einstellungen und das Blatt der
 * Antwortlänge teilen: Emojis, „Absenden nach Stille" (lib/stille-wahl.ts).
 * Er steht für sich, damit die Bausteine, die ihn nutzen, einander nicht
 * einbinden müssen: schnell-einstellungen → stille-auto-zeile → stille-wahl →
 * stufen-wahl, nie zurück.
 */

/** Eine Stufenwahl: das Element und wie es den Stand zeigt. */
export interface StufenWahl<T> {
  el: HTMLElement;
  /** Markiert die geltende Stufe; `null` markiert keine. */
  zeige(aktiv: T | null): void;
}

/**
 * Eine Reihe gleich breiter Knöpfe, genau einer gewählt — dieselbe Bauform
 * und dieselben Klassen wie „Mikro von selbst öffnen“ in den Einstellungen
 * (`.einst-segmente`). Die Wahl meldet `waehle`; was gilt, zeigt `zeige`.
 */
export function baueStufenWahl<T>(
  name: string,
  stufen: ReadonlyArray<{ wert: T; text: string }>,
  waehle: (wert: T) => void,
): StufenWahl<T> {
  const el = document.createElement("div");
  el.className = "einst-segmente";
  el.setAttribute("role", "radiogroup");
  el.setAttribute("aria-label", name);
  const knoepfe = stufen.map((s) => {
    const b = document.createElement("button");
    b.type = "button";
    b.className = "einst-segment";
    b.setAttribute("role", "radio");
    b.setAttribute("aria-checked", "false");
    b.textContent = s.text;
    b.addEventListener("click", () => waehle(s.wert));
    el.appendChild(b);
    return { b, wert: s.wert };
  });
  return {
    el,
    zeige(aktiv) {
      for (const k of knoepfe) k.b.setAttribute("aria-checked", String(k.wert === aktiv));
    },
  };
}
